import React, { useEffect, useState, type ReactNode } from 'react';

export const useLazyImagePlaceholder = (url: string, containerId: string) => {
    const [fallback, setFallback] = useState<ReactNode | null>(null);

    useEffect(() => {
        const queryString = url.split('?')[1];
        const params = new URLSearchParams(queryString);

        const intrinsicHeight = Number(params.get('h')) || 0;
        const intrinsicWidth = Number(params.get('w')) || 0;

        if (intrinsicHeight && intrinsicWidth) {
            const intrinsicAspectRatio = intrinsicWidth / intrinsicHeight;

            const parentWidth =
                document.getElementById(containerId)?.clientWidth || 0;

            const renderedHeight =
                parentWidth / Number(intrinsicAspectRatio.toFixed(3));

            setFallback(
                <div
                    className="lazy_image_placeholder"
                    style={{
                        width: `${parentWidth}px`,
                        height: `${Math.round(renderedHeight)}px`,
                    }}
                ></div>,
            );
        }
    }, [url, containerId]);
    return fallback;
};
